import { render, staticRenderFns } from "./CustomiserButton.vue?vue&type=template&id=41e64ce6&"
import script from "./CustomiserButton.vue?vue&type=script&lang=js&"
export * from "./CustomiserButton.vue?vue&type=script&lang=js&"
import style0 from "./CustomiserButton.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseIcon: require('/opt/build/repo/storefront/components/atoms/Icon/BaseIcon.vue').default,TertiaryButton: require('/opt/build/repo/storefront/components/atoms/Button/TertiaryButton.vue').default})
